/**
 * 功能：公共转换处理
 * 参数：
 *      prefix：      前缀
 *      suffix：      后缀
 *      null-value：  Null值
 */

export function format(column, value)
{
  // Null值
  if (typeof (column.nullValue) != "undefined")
  {
    if(value == null)
      value = column.nullValue;
  }
  // 前缀
  if (typeof (column.prefix) != "undefined")
    value = column.prefix + value;
  // 后缀
  if (typeof (column.suffix) != "undefined")
    value = value + column.suffix;
  return value;
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/Slot/Common.js